import { create } from "../../../common/utils/zustand_state_manager";
import { IQualidadeService } from "../../../features/qualidade/data/services/qualidade_service";
import { QualidadeService } from "../../../features/qualidade/data/services/qualidade_service_impl";



//useAuditorService

type State = {
  qualidadeService: IQualidadeService,
};

export const useQualidadeService = create<State>((set, get) => ({
  qualidadeService: new QualidadeService(),
}));